export type BucketFileEntry = {
  id: number;
  file: string;
  filename: string;
  url: string;
  bucket_name: string;
};

export type BucketSelectedFile = {
  id: number;
  reference: string;
  filename: string;
  url: string;
};

export type OtherAttachmentEntry = {
  id: number | string;
  [key: string]: unknown;
};

export type OtherFileState = {
  id: string | number;
  file?: File | string;
  progress: number;
  error: boolean;
  errorMessage: string;
  name: string;
  url: string;
  abortController?: AbortController;
  bucket_name?: string;
  filename?: string;
  reference_number?: string;
  isDeleting?: boolean;
};

export function toBucketFileEntry(selected: BucketSelectedFile, bucketName: string): BucketFileEntry {
  return {
    id: selected.id,
    file: selected.reference,
    filename: selected.filename,
    url: selected.url,
    bucket_name: bucketName,
  };
}

export function fromBucketFileEntry(entry: BucketFileEntry): BucketSelectedFile {
  return {
    id: entry.id,
    reference: entry.file,
    filename: entry.filename,
    url: entry.url,
  };
}
